export const getProductVersion = () => process.env.REACT_APP_VERSION;
export const getBuildId = () => process.env.REACT_APP_BUILD_ID;
export const getProductInfo = (product) => `${product} v${getProductVersion()} Build ${getBuildId()}`;
//# sourceMappingURL=index.js.map